
import {useContext, useEffect} from 'react';
import './style/categories.css';
import CategoryBtn from './CategoryBtn';
import ProductComponent from './ProductComponent';
import { AppContext } from '../../../contextApi/ContextApi';
import NotFound404 from "../../NotFound404.jsx";

export default function Categories({website, isDashboard, setDisplay}) {
    const { primary_color, accent_color, hasCategories, categoryNow, setCategoryNow } = useContext(AppContext);
    useEffect(()=>{
        if(categoryNow===null || categoryNow === undefined){
            setCategoryNow(website?.settings?.categories[0]);
        }
    },[])
    if(!hasCategories) return <NotFound404/>
    const categoriesDeploy=()=>{
        if(website?.settings?.categories?.length === 0){
            return <h3 style={{margin:"50px auto 0", textShadow:`2px 2px 4px ${primary_color}`}}>עדיין לא התווספו קטגוריות</h3>
        }
        //  according to number of categories exists, return buttons to change products
        return website?.settings?.categories?.map((val,inx)=>{
            return <CategoryBtn website={website} key={`categoryBtn_inx_${inx}`} logoPath={val} name={val.name} change={()=>{setCategoryNow(val)}} categoryNow={categoryNow} inx={inx}/>
        })
    }

    const returnCategoryRequested=()=>{
        if(categoryNow?.products?.length === 0){
            return <h3 style={{margin:"0 auto", textShadow:`2px 2px 4px ${primary_color}`}}>אין מוצרים עדיין בקטגוריה זו</h3>
        }
        //  then return components for every product at that category
        return <div className='productsComponentsDiv'>
            {categoryNow?.products?.map((val, inx)=>{
                return <ProductComponent key={`productComponent_inx_${inx}`} website={website} val={val} inx={inx} isDashboard={isDashboard} setDisplay={setDisplay}/>
            })}
        </div>
    }

  return (
    <div className='categoriesMainContainer'>
        <h1 style={{margin:"50px auto 0", color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}} dir='rtl'>המוצרים שלנו</h1>
        <div className='categoryBtnsContainer'>
            {categoriesDeploy()}
        </div>
        {website?.settings?.categories?.length > 0 &&
            <div className='productsComponentsContainer'>
                {returnCategoryRequested()}
            </div>
        }
    </div>
  )
}
